import { SxProps } from '@mui/material'

export const styles: Record<string, SxProps> = {
	container: {
		textAlign: 'center',
		gap: '3.2rem',
		margin: '12.8rem 10rem',
		sm: { margin: '6.4rem' },
	},
	subtitle: {
		marginTop: '3.2rem',
	},
	licenseText: {
		color: '#45657B',
		marginTop: '3.2rem',
	},
	licenseLink: {
		color: '#45657B',
		textDecorationColor: '#45657B',
	},
	button: {
		marginTop: '3.2rem',
	},
}
